import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';

const Promocode = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle="Promocode" parent="Application" title="Promocode" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <h5>Promocode Management</h5>
                <p>This is the promocode page.</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Promocode;
